import { useState } from "react";
import { MenuItem, Select, Box } from "@mui/material";
import arrowDownImage from "../../../assets/images/arrow-down.png";

const SystemSelect = ({ onChange, value, availableSystems }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Select
            labelId="system-select"
            id="system-select"
            value={value ?? ""}
            label="System"
            onChange={onChange}
            onOpen={handleOpen}
            onClose={handleClose}
            sx={{
                fontSize: "14px",
                height: "38px",
                backgroundColor: "#eef8ff",
                border: "none",
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#bae1ff",
                    cursor: "pointer",
                },
                "&.Mui-focused": {
                    backgroundColor: "#bae1ff",
                    cursor: "pointer",
                },
                "& .MuiSelect-icon": {
                    fontSize: "22px",
                    display: "none",
                },

                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Uklanja border
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Uklanja border na hover
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Uklanja border kada je fokusiran
                },
            }}
            IconComponent={() => (
                <Box
                    component="img"
                    src={arrowDownImage}
                    alt="dropdown arrow"
                    sx={{
                        pointerEvents: "none",
                        cursor: "pointer",
                        width: 24,
                        height: 24,
                        transition: "transform 0.3s ease",
                        transform: open ? "rotate(180deg)" : "rotate(0deg)",
                        position: "absolute",
                        right: "4px",
                    }}
                />
            )}
            MenuProps={{
                PaperProps: {
                    sx: {
                        // Stil za ceo padajući meni
                        "& .MuiMenuItem-root": {
                            // Stil za sve MenuItem opcije
                            "&.Mui-selected": {
                                backgroundColor: "#eef8ff", // Plava pozadina za selektovanu opciju
                                "&:hover": {
                                    backgroundColor: "#bae1ff", // Tamnija plava na hover
                                },
                            },
                            "&.Mui-focused , &.Mui-activated": {
                                backgroundColor: "#eef8ff",
                            },
                        },
                    },
                },
            }}
        >
            {availableSystems?.map((system) => {
                return (
                    <MenuItem key={system.id} value={system.name}>
                        {system.name}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default SystemSelect;
